import Button from "components/Button";
import Dialog from "components/Dialog";
import Stack from "components/Stack";
import Text from "components/Text";

export interface IConnectionResendDialog {
  onConfirm: () => void;
  onClose: () => void;
  open: boolean;
}

export const ConnectionResendDialog = ({
  onConfirm,
  onClose,
  open,
}: IConnectionResendDialog) => {
  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={onClose}>
      <Stack alignSelf="center" padding={4} spacing={2}>
        <Text variant="text1">
          It seems that less than 50% of the uploaded files were matched with a
          certain field. Do you want to start the matching process again?
        </Text>
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button variant="text" onClick={onClose} data-testid="cancel-button">
            Cancel
          </Button>
          <Button onClick={onConfirm}>Confirm</Button>
        </Stack>
      </Stack>
    </Dialog>
  );
};
